<template>
  <div class="swiper-container" id="swiperBox">
    <div class="swiper-wrapper">
      <div class="cel swiper-slide" v-for="(item, index) in bubbleList" :key="index">
        <p class="img"><img :src="item.headPortrait"></p>
        <p class="tips clamp-1">{{ item.bubbleTxt }}</p>
      </div>                                   
    </div>
  </div>       
</template>    

<script>
import Swiper from 'swiper'
import { mapGetters } from 'vuex'

export default {
  name: 'bubble',
  props: {
    bubbleList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  mounted() {
    this.swiperInte()
  },
  methods: {
    swiperInte() {
      this.$nextTick(() => {
        this.leftBannerSwiper = new Swiper('#swiperBox', {
          autoplay: 1500,
          speed: 1000,
          direction: 'vertical',
          loop: true,
          spaceBetween: 5,
          // 手指触摸后，重新开启自动轮播
          autoplayDisableOnInteraction: false
        })
      })
    }
  },
  computed: {
    ...mapGetters(['appCont'])
  }
}
</script>

<style lang="less" scoped>
  .swiper-container{
      height: 0.6rem;
      overflow: hidden;
    }    
  .cel{      
    width: 4rem;
    height: 0.6rem;
    display: flex;
    align-items: center;      
    background: rgba(20,0,50,0.3);
    border-radius: 0.6rem;
    padding:0 0.08rem;
    .img{
      width: 0.44rem;
      height: 0.44rem;
      border-radius: 100%;
      border: 2px solid #fff;
      margin-right: 0.18rem;      
      flex-shrink: 0;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;              
      }        
    }
    .tips{
      font-size: 0.2rem;
      font-weight: bold;
      color: #FFFAB4;
      line-height: 0.6rem;
      padding-top: 0.04rem;
    }
  }
</style>
